const AVAILITY_SUBSCRIBER_RELATIONSHIP_SELF = "18";
const AVAILITY_SUBSCRIBER_RELATIONSHIP_SPOUSE = "1";
const AVAILITY_SUBSCRIBER_RELATIONSHIP_CHILD = "19";
const AVAILITY_SUBSCRIBER_RELATIONSHIP_OTHER = "34";

const AVAILITY_SUBSCRIBER_RELATIONSHIPS = [
  {
    code: AVAILITY_SUBSCRIBER_RELATIONSHIP_SELF,
    label: "Self"
  },
  {
    code: AVAILITY_SUBSCRIBER_RELATIONSHIP_SPOUSE,
    label: "Spouse"
  },
  {
    code: AVAILITY_SUBSCRIBER_RELATIONSHIP_CHILD,
    label: "Child"
  },
  {
    code: AVAILITY_SUBSCRIBER_RELATIONSHIP_OTHER,
    label: "Other"
  }
];

export {
  AVAILITY_SUBSCRIBER_RELATIONSHIPS,
  AVAILITY_SUBSCRIBER_RELATIONSHIP_SELF,
  AVAILITY_SUBSCRIBER_RELATIONSHIP_SPOUSE,
  AVAILITY_SUBSCRIBER_RELATIONSHIP_CHILD,
  AVAILITY_SUBSCRIBER_RELATIONSHIP_OTHER
};
